import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import http from '../utils/http';
import { RootState } from './store';


export interface AuditorReference {
    name: string;
    code: string;
    branchId: string;
}
export interface AuditorsState {
    allAuditors: Array<AuditorReference>;
    status: 'idle' | 'loading' | 'failed';
}

const initialState: AuditorsState = {
    allAuditors: [],
    status: "idle"
}

export const getAllAuditorsAsync = createAsyncThunk(
    "Auditor/GetAllAuditors",
    async (): Promise<Array<AuditorReference>> => {
        try {
            const result = await http<undefined, Array<AuditorReference>>({
                path: `/auditor/allAuditors`,
                method: 'get'
            });
            if (result.ok && result.parsedBody) {
                return result.parsedBody;
            }
            else {
                return new Array<AuditorReference>();
            }
        } catch (ex) {
            return new Array<AuditorReference>();
        }
    });


export const auditorsSlice = createSlice({
    name: 'Auditors',
    initialState,
    reducers: {
    },
    extraReducers: (builder: any) => {
        builder
            .addCase(getAllAuditorsAsync.pending, (state: any) => {
                state.status = "loading";
            })
            .addCase(getAllAuditorsAsync.fulfilled, (state: any, action: any) => {
                state.allAuditors = action.payload;
                state.status = "idle";
            })

    },
});

export const { } = auditorsSlice.actions;

export const selectAuditors = (state: RootState) => state.auditors ? state.auditors.allAuditors : [];


export default auditorsSlice.reducer;